import { render, staticRenderFns } from "./AuthBase.vue?vue&type=template&id=0715e87e&scoped=true"
import script from "./AuthBase.vue?vue&type=script&lang=js"
export * from "./AuthBase.vue?vue&type=script&lang=js"
import style0 from "./AuthBase.vue?vue&type=style&index=0&id=0715e87e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0715e87e",
  null
  
)

export default component.exports